import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class FaqList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: false
    };

    this.error = this.error.bind(this);
    this.insertCategory = this.insertCategory.bind(this);
    this.deleteCategory = this.deleteCategory.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  insertCategory() {
    this.props.history.push("/helpdesk/faq/form");
  }

  deleteCategory(id) {
    axios
      .post(`${URL.api}helpdesk/faq/delete/${id}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          axios
            .get(`${URL.api}helpdesk/faq/list`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              resp => {
                this.setState(
                  () => ({
                    list: null
                  }),
                  () => {
                    if (resp.data.data.length === 0) {
                      this.setState(() => ({
                        list: [],
                        loading: false
                      }));
                    } else {
                      this.setState(
                        () => ({
                          list: resp.data.data,
                          loading: false
                        }),
                        () => {
                          this.forceUpdate();
                        }
                      );
                    }
                  }
                );
              },
              error => {
                this.error(error.response.statusText);
              }
            );
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}helpdesk/faq/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data,
                    loading: false
                  }),
                  () => {
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  getSlateText(text) {
    const parsed = JSON.parse(text);

    return parsed
      .reduce(
        (acc, val) =>
          `${acc} ${val.children.reduce(
            (acc2, val2) => acc2 + (val2.text || ""),
            ""
          )}`,
        ""
      )
      .trim();
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list.map(item => ({
                    ...item,
                    question: this.getSlateText(item.question),
                    answer: this.getSlateText(item.answer)
                  }))}
                  path="/helpdesk/faq/edit/"
                  title="FAQ"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "question", denomination: "Pergunta" },
                    { name: "answer", denomination: "Resposta" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertCategory}
                  deleteAction={this.deleteCategory}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FaqList);
